import { useEffect, useRef, useCallback } from "react";
import { PropTypes } from "prop-types";
import { useLocation } from "react-router-dom";
import AppHOC from "../AppHOC";
import { useMount } from "../../utils/genericCommon";
import { getLicenseData } from "./utils";
import { setFeatures } from "../AppHOC/actions";
import { routeURLs } from "../../utils/enums";

const defaultData = {
  fabric: null,
  loader: true,
  error: null,
  available: [],
  enabled: []
};

const AuthLicense = ({ globalFilter }) => {
  const location = useLocation();
  const mount = useMount();
  const dataRef = useRef({ timestamp: 0, features: { ...defaultData } });

  useEffect(() => {
    if (location.pathname !== routeURLs.accounts) {
      if (globalFilter.selectedOverlay) {
        if (globalFilter.selectedOverlay !== dataRef.current.features.fabric) {
          const timestamp = Date.now();
          dataRef.current.timestamp = timestamp;
          Object.assign(dataRef.current.features, defaultData, {
            fabric: globalFilter.selectedOverlay
          });
          getData(timestamp);
        }
      } else Object.assign(dataRef.current.features, defaultData, {
        loader: false
      });
      if (JSON.stringify(globalFilter.features) !== JSON.stringify(
        dataRef.current.features
      )) setFeatures(dataRef.current.features);
    }
  }, [globalFilter.selectedOverlay, location.pathname]);

  const getData = useCallback(async timestamp => {
    const res = await getLicenseData();
    if (mount.mounted === true && timestamp === dataRef.current.timestamp) {
      if (res.errorObject instanceof Object) {
        dataRef.current.features.error = res.errorObject;
        dataRef.current.features.fabric = null;
      }
      else if (
        res.data instanceof Object && res.data.features instanceof Object
      ) {
        const featuresMap = Object.entries(res.data.features);
        const available = featuresMap
          .filter(item => item[1].feature_available === true);
        dataRef.current.features.available = available.map(item => item[0]);
        dataRef.current.features.enabled = available
          .filter(item => item[1].feature_enabled === true)
          .map(item => item[0]);
      }
      dataRef.current.features.loader = false;
      setFeatures(dataRef.current.features);
    }
  }, []);

  return null;
};

AuthLicense.propTypes = {
  globalFilter: PropTypes.object.isRequired
};

export default AppHOC(AuthLicense);
